Object.defineProperty(exports,"__esModule",{value:true});var _protobufDeserializer=require('./protobufDeserializer');var _protobufDeserializer2=_interopRequireDefault(_protobufDeserializer);
var _topics=require('./topics');
var _clearFromIds=require('./clearFromIds');var _clearFromIds2=_interopRequireDefault(_clearFromIds);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=





function(topic,binaryPayload){
var protoObject=(0,_protobufDeserializer2.default)(topic,binaryPayload);

if(!protoObject){
console.log('Couldn\'t parse binary payload from \''+
topic+'\' topic. No action can be dispatched.');

return null;
}

var action=(0,_topics.mapper)(topic)(protoObject);

if(action){
return action;
}else{
console.log('Couldn\'t map to action for topic \''+
topic+'\'. No action can be dispatched.');

return null;
}
};